import type { OiSummary } from '@/lib/api/types';
import { queryClient } from '@/lib/query';

/** The aircraft (drone_id) an OI belongs to.
 *
 *  An OI's own id (a UUID / declaration id) is NOT its aircraft's serial, and
 *  every per-aircraft MQTT topic is keyed by the serial — so anything that needs
 *  "the topics of the selected OI" must resolve through this first. REST-first
 *  (the OI list cache), falling back to the live per-drone OI envelopes when the
 *  list isn't loaded — the same order `layers/waypoints.ts` and `layers/oi.ts`
 *  use. Null when the OI is unknown or none is selected. */
export function aircraftForOi(
  oiId: string | null,
  byId: Readonly<
    Record<string, { telemetry: { drone_id: string }; oi?: { oi_id?: string } | null }>
  >,
): string | null {
  if (!oiId) return null;
  const oiList = queryClient.getQueryData<OiSummary[]>(['oi', 'list']) ?? [];
  const fromRest = oiList.find((o) => o.oi_id === oiId)?.aircraft;
  if (fromRest) return fromRest;
  for (const d of Object.values(byId)) {
    if (d.oi?.oi_id === oiId) return d.telemetry.drone_id;
  }
  return null;
}
